import { Card } from "antd";
import { Icon } from "lucide-react";
import { connect } from "react-redux";

const AttendanceSummaryCard = ({ type, count, icon: Icon }) => {
  const key = type.toLowerCase();
  const attendanceColors = {
    present: { border: "border-emerald-200", bg: "bg-emerald-50", text: "text-emerald-600" },
    late: { border: "border-amber-200", bg: "bg-amber-50", text: "text-orange-600" },
    absent: { border: "border-red-200", bg: "bg-red-50", text: "text-red-600" },
    "on leave": { border: "border-blue-200", bg: "bg-blue-50", text: "text-blue-600" },
    };
  const color = attendanceColors[key];
  
    

  return (
    <div className={`flex flex-col gap-6 rounded-xl border ${color.border} ${color.bg} p-4`}>
      <div className="flex items-center gap-2">
        <span className="flex items-center justify-center">
          <Icon className={`${color.text} w-5 h-5`} />
        </span>
        <div>
          <p className="text-[11px] text-muted-foreground">{type}</p>
          <p className={`text-[20px] font-semibold ${color.text}`}>{count}</p>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({});
const mapDispatchToProps = (dispatch) => ({});

export default connect(mapStateToProps, mapDispatchToProps)(AttendanceSummaryCard);
